import React, { ButtonHTMLAttributes } from "react";
import { ArrowIcon, ButtonContent, StyledButton } from "./Button.styles";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "arrow";
  outlined?: boolean;
  small?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "default",
  outlined = false,
  small = false,
  type = "button",
  ...props
}) => {
  return (
    <StyledButton
      type={type}
      $withArrow={variant === "arrow"}
      $outlined={outlined}
      $small={small}
      {...props}
    >
      <ButtonContent
        $withArrow={variant === "arrow"}
        $outlined={outlined}
        $small={small}
      >
        {children}
      </ButtonContent>
      {variant === "arrow" && (
        <ArrowIcon $outlined={outlined} aria-hidden="true">
          <i className="pi pi-arrow-up-right" />
        </ArrowIcon>
      )}
    </StyledButton>
  );
};

export default Button;
